<template>
   <div class="modal fade" id="form_popup" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">

              <!-- Modal Header with close button -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body" id="modal_content">
                  <div class="row">
                     <div class="col-md-12">
                        <p class="alert alert-info alert-sm"><b>Syringe Exchange Services</b></p>
                     </div>

                     <div class="col">
                        <label>Needle Out</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.NeedleOut">
                     </div>
                     <div class="col">
                        <label>Needle Type</label>
                        <select class="form-control form-control-sm" v-model="clientService.NeedleType">
                           <option value="">-</option>
                           <option value="23G">Needle 23G</option>
                           <option value="24G">Needle 24G</option>
                           <option value="25G">Needle 25G</option>
                           <option value="26G">Needle 26G</option>
                        </select>
                     </div>
                     <div class="col">
                        <label>Syringe Out</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.SyringeOut">
                     </div>
                     <div class="col">
                        <label>Syringe In</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.SyringeIn">
                     </div>
                     <div class="col">
                        <label>Syringe Type</label>
                        <select class="form-control form-control-sm" v-model="clientService.SyringeType">
                           <option value="">-</option>
                           <option value="2CC">Syringes 2ML</option>
                           <option value="3CC">Syringes 3ML</option>
                           <option value="5CC">Syringes 5ML</option>
                        </select>
                     </div>
                     <div class="col">
                        <label>Alcohol Swabs / Alcohol Pads</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.SpiritSwab">
                     </div>
                     <div class="col">
                        <label>Disposable First Aid Bandages</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.Bandage">
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-md-9">
                        <p class="alert alert-info alert-sm"><b>Mask & Sanitizer</b></p>
                     </div>

                     <div class="col-md-3 alert alert-info alert-sm">
                     </div>
                     <div class="col-md-3" style="display: none;">
                        <label>Surgical Face Mask</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.SurgicalFaceMask">
                     </div>
                     <div class="col-md-3" style="display: none;">
                        <label>Hand Sanitizer</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.HandSanitizer">
                     </div>
                     <div class="col-md-3" style="display: none;">
                        <label>Hand Sanitizer Type</label>
                        <select class="form-control form-control-sm" v-model="clientService.HandSanitizerType">
                           <option value="">-</option>
                           <option value="250ml">250ml</option>
                           <!-- <option value="500ml">500ml</option> -->
                        </select>
                     </div>
                     <div class="col-md-3">
                        <label>Male latex Condom</label>
                        <input type="number" class="form-control form-control-sm" v-model="clientService.Condoms">
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-md-5">
                        <p class="alert alert-info alert-sm"><b>BCC Services</b></p>
                     </div>
                     <div class="col-md-4">
                        <p class="alert alert-info alert-sm"><b>Hygiene Services</b></p>
                     </div>
                     <div class="col-md-3">
                        <p class="alert alert-info alert-sm"><b>VCCT</b></p>
                     </div>
                     <div class="col-md-5">
                        <div class="row">
                           <div class="col">
                              <label>HIV
                                 <input type="checkbox" v-model="clientService.IsHIV">
                              </label>
                           </div>
                           <div class="col">
                              <label>STIs
                                 <input type="checkbox" v-model="clientService.IsSTIs">
                              </label>
                           </div>
                           <div class="col">
                              <label>SIP
                                 <input type="checkbox" v-model="clientService.IsSIP">
                              </label>
                           </div>
                           <div class="col">
                              <label>Safer Sex
                                 <input type="checkbox" v-model="clientService.IsSaferSex">
                              </label>
                           </div>
                        </div>
                     </div>
                     <div class="col-md-4">
                        <div class="row">
                           <div class="col">
                              <label>Haricut
                                 <input type="checkbox" v-model="clientService.IsHaircut">
                              </label>
                           </div>
                           <div class="col">
                              <label>Shave
                                 <input type="checkbox" v-model="clientService.IsShave">
                              </label>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-md-12">
                        <p class="alert alert-info alert-sm"><b>Add Clients</b></p>
                     </div>
                     <div class="col-md-3">
                        <input type="text" class="form-control form-control-sm" v-model="regNo" v-on:keyup.enter="findClient" v-on:keydown.tab="findClient" id="client_reg_no" placeholder="Reg No">
                     <span class="d-error" style="display:none; color:red">Reg No already added</span>
                     </div>
                     <div class="col-md-2">
                        <button type="button" class="btn btn-info btn-sm" v-on:click="findClient">Find <i class="fa fa-spin fa-spinner loader2 to_be_hidden" style="display: none;"></i></button>
                        <p class="text-danger display_none" id="not_found"><b>Not found</b></p>
                     </div>
                     <div class="col-md-5">
                        <p class="display_none c_detail"><b>Name</b><span class="cp_name"></span>, <b>DUT</b><span class="cp_dut"></span> </p>
                     </div>
                     <div class="col-md-2">
                        <!-- <button type="button" class="btn btn-primary display_none" id="add_to_list">Add to List <i class="fa fa-spin fa-spinner loader2 to_be_hidden" style="display: none;"></i></button> -->
                        <!-- <input type="hidden" class="c_count" value="0"> -->
                     </div>
                     <div class="col-md-12 mt-1">
                        <table class="table table-bordered">
                           <thead>
                              <tr class="alert alert-info alert-sm">
                                 <th colspan="4">Clients List <span class="badge badge-success">{{ ClientList.length }}</span></th>
                              </tr>
                              <tr>
                                 <th>S.no</th>
                                 <th>Reg No</th>
                                 <th>Name</th>
                                 <th>DUT</th>
                                 <th>Action</th>
                              </tr>
                           </thead>
                           <tbody id="clients_list">
                               <tr v-for="(client, index) in ClientList" :key="index">
                                   <td> {{ index + 1 }}</td>
                                   <td> {{ client.Reg }}</td>
                                   <td> {{ client.Name }}</td>
                                   <td> {{ client.DUT }}</td>
                                   <td> <button class="btn btn-danger btn-sm" v-on:click="removeRow(index)"><i class="fa fa-trash fa-sm"></i> </button></td>
                               </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
        </div>
        <div class="modal-footer">
          <button type="submit" form="role_form" class="btn btn-dark btn-sm text-center full_width" v-on:click="populateClients">Populate</button>
          <button type="button" class="btn btn-secondary btn-sm text-center full_width" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'initial-modal-orw-service',
    props: ['cityId', 'ServiceDate'],
    data() {
        return {
            regNo: null,
            ClientList: [],
            sortedList: [],
            unsortedList: [],
            clientService: {
                NeedleOut: 0,
                NeedleType: "",
                SyringeOut: 0,
                SyringeIn: 0,
                SyringeType: '',
                SpiritSwab: 0,
                Bandage: 0,
                SurgicalFaceMask: 0,
                HandSanitizer: 0,
                HandSanitizerType: '',
                Condoms: 0,
                IsHIV: 0,
                IsSTIs: 0,
                IsSIP: 0,
                IsSaferSex: 0,
                IsHaircut: 0,
                IsShave: 0,
            }
        };
    },
    methods: {
        test() {
            alert('asdfsaf');
        },
        findClient() {
            axios.get('client-detail', {
                params: {
                    reg_no: this.regNo,
                    city: this.cityId,
                    service_date: this.ServiceDate,
                }
            })
            .then((response) => {
                if (response.data.status === true) {
                    let newClient = response.data.data;
                     document.querySelector('.d-error').style.display = 'none';
                    // Prevent duplicates before adding
                    if (!this.ClientList.some(client => client.Reg === newClient.Reg)) {
                        this.sortedList.unshift(newClient);
                        this.ClientList.unshift(newClient);
                        this.unsortedList.push(newClient);
                    }else{document.querySelector('.d-error').style.display = 'inline';}
                } else {
                  document.querySelector('.d-error').style.display = 'none';
                    alert(response.data.data.msg);
                }

                this.regNo = "";
                $("#client_reg_no").focus();
            })
            .catch(() => {})
            .finally();
        },
        removeRow(index) {
            let removedClient = this.ClientList[index];

            // Remove from all lists
            this.ClientList.splice(index, 1);
            this.sortedList = this.sortedList.filter(client => client.Reg !== removedClient.Reg);
            this.unsortedList = this.unsortedList.filter(client => client.Reg !== removedClient.Reg);
        },
        populateClients() {
            // Ensure only the latest ClientList is used
           window.clientlist = this.unsortedList;
                     window.clientServiceObject = this.clientService;
                     window.populateRecords();
            $('#form_popup').modal('hide');
        }
    }
};
</script>

<style lang="scss" scoped>
    #modal_content {
        font-size: 12px;
    }
    .alert-sm{
        padding: 0;
        padding-left: 9px;
        margin-bottom: 6px;
        margin-top: 5px;
    }
</style>
